module.exports = __webpack_public_path__ + "media/promo/promo/images/soc-1-e7cab86634a70a04e0ce7f39e84a82dc.svg";